{
  "actions": "Veiksmai",
  "actionsAvailable": "Galimi veiksmai.",
  "clearSelection": "Išvalyti pasirinkimą",
  "selected": "{count, plural, =0 {Nieko nepasirinkta} other {Pasirinkta #}}",
  "selectedAll": "Pasirinkta viskas"
}
